<script setup lang="ts">
import { computed, ref } from 'vue';
import { useRoute } from 'vue-router';
import { usePageTitle } from '@/shared/composables/usePageTitle';

import { useLogout } from '@/shared/composables/useLogout';

usePageTitle('Access Denied');

const route = useRoute();
const { logout } = useLogout();

const loggingOut = ref(false);

const customMessage = computed(() => route.query.message as string | undefined);

const error = computed(() => ({
  statusCode: 403,
  statusMessage: 'Access denied',
  message: customMessage.value || 'Your account doesn\'t have access to the OhMyBible admin.',
}));

const handleLogout = async () => {
  loggingOut.value = true;
  await logout();
};
</script>

<template>
  <UError
    :error="error"
    :clear="false"
    data-testid="u-error"
  >
    <template #links>
      <!-- No "Go home": the auth middleware sends a user without admin access
           straight back here, so signing in as someone else is the way out. -->
      <UButton
        size="lg"
        color="primary"
        label="Sign out"
        :loading="loggingOut"
        data-testid="access-denied-sign-out"
        @click="handleLogout"
      />
    </template>
  </UError>
</template>
